import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UnlinkOrderFulfillmentPicturesMutationVariables = Types.Exact<{
  picture_ids: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;


export type UnlinkOrderFulfillmentPicturesMutation = { __typename?: 'Mutation', unlinkOrderFulfillmentPictures: number };


export const UnlinkOrderFulfillmentPicturesDocument = gql`
    mutation UnlinkOrderFulfillmentPictures($picture_ids: [ID!]!) {
  unlinkOrderFulfillmentPictures(picture_ids: $picture_ids)
}
    `;
export type UnlinkOrderFulfillmentPicturesMutationFn = Apollo.MutationFunction<UnlinkOrderFulfillmentPicturesMutation, UnlinkOrderFulfillmentPicturesMutationVariables>;

/**
 * __useUnlinkOrderFulfillmentPicturesMutation__
 *
 * To run a mutation, you first call `useUnlinkOrderFulfillmentPicturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkOrderFulfillmentPicturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkOrderFulfillmentPicturesMutation, { data, loading, error }] = useUnlinkOrderFulfillmentPicturesMutation({
 *   variables: {
 *      picture_ids: // value for 'picture_ids'
 *   },
 * });
 */
export function useUnlinkOrderFulfillmentPicturesMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkOrderFulfillmentPicturesMutation, UnlinkOrderFulfillmentPicturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkOrderFulfillmentPicturesMutation, UnlinkOrderFulfillmentPicturesMutationVariables>(UnlinkOrderFulfillmentPicturesDocument, options);
      }
export type UnlinkOrderFulfillmentPicturesMutationHookResult = ReturnType<typeof useUnlinkOrderFulfillmentPicturesMutation>;
export type UnlinkOrderFulfillmentPicturesMutationResult = Apollo.MutationResult<UnlinkOrderFulfillmentPicturesMutation>;
export type UnlinkOrderFulfillmentPicturesMutationOptions = Apollo.BaseMutationOptions<UnlinkOrderFulfillmentPicturesMutation, UnlinkOrderFulfillmentPicturesMutationVariables>;